import {backAdmin} from "../axios";

export const reportsApi = [
    {url: `${backAdmin}/reports/country`, name: 'reports.country', method: 'GET'},
    {url: `${backAdmin}/reports/connections`, name: 'reports.connections', method: 'GET'},
    {url: `${backAdmin}/reports/users`, name: 'reports.users', method: 'GET'},
]